// JsFromRoutes CacheKey ef9fc9811fcf9d4c9771a92f7414f2b8
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  autocomplete: /* #__PURE__ */ definePathHelper('get', '/cities/autocomplete'),
  AutocompleteProfile: /* #__PURE__ */ definePathHelper('get', '/cities/autocomplete_profile'),
}
